module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/mojito_b54fdc.jpg";